module.exports = __webpack_public_path__ + "static/media/bg-2.377e7279.png";